import React, { Component } from 'react';
import SorContext from "./SorContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import './sor.css'


class SortByFilter extends Component {
    constructor (props) {
        super(props);
        this.state = {
            selectedCount: 0,
            sortByFilter: [
                // { id: '1', name: 'Company hierarchy', selected: 0 },
                { id: '2', name: 'Surname', selected: 0 },
                { id: '3', name: 'Forename', selected: 0 },
                { id: '4', name: 'Regime type and responsibility', selected: 0 },
            ]
        };
    }
    static contextType = SorContext;

    componentDidMount = () => {
        this.setComponentState();
    }


    setComponentState = () => {
        const { selected_report_parameter } = this.context;
        let sortBy = this.state.sortByFilter;
        let sfilter = selected_report_parameter.firstSection.sortByFilter;
        let updatedData = []
        if (sfilter.value != 'all') {
            updatedData = sortBy.map(item => {
                if (sfilter.value.includes(item.id)) {
                    return { ...item, selected: item.selected === 0 ? 1 : 0 };
                }
                return item;
            });
            this.setState({
                sortByFilter: updatedData,
                selectedCount: updatedData.filter(item => item.selected === 1).length
            });
        }
    }


    selectedsortBy = (e, Id) => {
        e.preventDefault();
        let sortBy = this.state.sortByFilter;
        const updatedData = sortBy.map(item => {
            if (item.id == Id) {
                return { ...item, selected: item.selected === 0 ? 1 : 0 };
            }
            return item;
        });

        this.setState({
            sortByFilter: updatedData,
            selectedCount: updatedData.filter(item => item.selected === 1).length
        });
    };

    closesortByFilter = () => {
        let sortByFilter = this.state.sortByFilter;
        const { updateFilterParameter } = this.context;
        let obj = {
            type: 'sortByFilter',
            secondaryText: "",
            value: ""
        }

        if (this.state.selectedCount != 0) {
            const selectedObjects = sortByFilter.filter(item => item.selected == 1);
            let names = "", ids = "";
            selectedObjects.forEach((e) => {
                names += e.name + ','
                ids += e.id + ','
            })
            names = names.slice(0, -1);
            ids = ids.slice(0, -1);

            obj.secondaryText = names;
            obj.value = ids
        } else {
            obj.secondaryText = 'All levels(Default)';
            obj.value = 'all'
        }


        updateFilterParameter(obj)
        this.props.closeFilter();
    }


    render() {
        return (
            <div className='personnel-container'>
                <span class="select-smr-popover-selected" id="spanSelectCount">Show selected
                    ({this.state.selectedCount} selected)</span>
                <div className='personnel-employee-container'>
                    <div style={{ marginLeft: '12px' }} className='personnel-employees'>
                        <ul>
                            {this.state.sortByFilter.map((item, index) => (
                                <React.Fragment>
                                    <li className='personnel-li' key={index} onClick={(e) => this.selectedsortBy(e, item.id)}>
                                        {item.selected == 1 && <FontAwesomeIcon ktitle="Action" className='personnel-check-icon'
                                            icon={solid('check')}>
                                        </FontAwesomeIcon>}{item.name}
                                    </li>
                                </React.Fragment>
                            ))}

                        </ul>
                    </div>
                    <button className='personnel-employee-done' onClick={this.closesortByFilter}>Done</button>
                </div>
            </div >
        )
    }
}

export default SortByFilter
